export const  GET_SUBSCRIPTION_REQUEST='notesReducer/GET_SUBSCRIPTION_REQUEST';
export const  GET_SUBSCRIPTION_SUCCESS='notesReducer/GET_SUBSCRIPTION_SUCCESS';
export const  GET_SUBSCRIPTION_FAILED='notesReducer/GET_SUBSCRIPTION_FAILED';